import React, { useState, useEffect, useCallback } from "react";
import { useSelector, useDispatch } from "react-redux";
import {
  createBiopsySlice,
  getBiopsyListSlice,
  getBiopsyByIdSlice,
  updateBiopsySlice,
  deleteBiopsySlice,
  resetCreateMessages,
  resetUpdateMessages,
  resetDeleteMessages,
} from "../../../store/slices/biopsy";

import { Modal } from "react-bootstrap";
import {
  showToastifySuccess,
  showToastifyError,
} from "../../common/tostify/Toastifyresponse";
import Table from "../../common/Table/table";
import AddUpdateBiopsy from "./addUpdateBiopsy";
import ShowTostifyMessageAndReset from "../../common/showTostifyMessageAndReset/showTostifyMessageAndReset";
import ViewModal from "../../common/viewModal/globalViewModal";

const BiopsyTracking = () => {
  const dispatch = useDispatch();

  const [showModal, setModalVisible] = useState(false);
  const [showDeleteModal, setDeleteModalVisible] = useState(false);
  const [modalAction, setModalAction] = useState(null);
  const [deleteId, setDeleteId] = useState(null);
  const [searchValue, setSearchValue] = useState("");
  const [showGlobalViewModal, setShowGlobalViewModal] = useState(false);
  const [pageLimit, setPageLimit] = useState(10);
  const [submitLoading, setSubmitLoading] = useState(false);

  const [formData, setFormData] = useState({
    appointmentId: "",
    sample_rcv_dt: "",
    sample_rcv_time: "",
    grossing_dt: "",
    grossing_time: "",
    slide_formation_dt: "",
    slide_formation_time: "",
    slide_rcv_dt: "",
    slide_rcv_time: "",
    report_dt: "",
    report_time: "",
  });

  const showTostifyMessageAndReset = ShowTostifyMessageAndReset();

  const {
    biopsy,
    biopsyById,
    createBiopsySuccessMessage,
    createBiopsyErrorMessage,
    updateBiopsySuccessMessage,
    updateBiopsyErrorMessage,
    deleteBiopsySuccessMessage,
    deleteBiopsyErrorMessage,
    currentPage,
    totalPages,
    totalCount,
    loading,
  } = useSelector((state) => state.BiopsyTracking);

  const { clinicInfo } = useSelector((state) => state.clinic);
  const { token } = useSelector((state) => state.auth);

  const clinicId = clinicInfo?.[0]?.clinicId;

  const fetchBiopsy = useCallback(
    (page = 1, lim = pageLimit) => {
      if (clinicId && token) {
        dispatch(
          getBiopsyListSlice({
            clinicId,
            token,
            currentPage: page,
            limit: lim,
          }),
        );
      }
    },
    [dispatch, clinicId, token, pageLimit],
  );

  useEffect(() => {
    fetchBiopsy();
  }, [fetchBiopsy]);

  useEffect(() => {
    showTostifyMessageAndReset(
      createBiopsySuccessMessage,
      showToastifySuccess,
      resetCreateMessages,
    );
    showTostifyMessageAndReset(
      createBiopsyErrorMessage,
      showToastifyError,
      resetCreateMessages,
    );
    showTostifyMessageAndReset(
      updateBiopsySuccessMessage,
      showToastifySuccess,
      resetUpdateMessages,
    );
    showTostifyMessageAndReset(
      updateBiopsyErrorMessage,
      showToastifyError,
      resetUpdateMessages,
    );
    showTostifyMessageAndReset(
      deleteBiopsySuccessMessage,
      showToastifySuccess,
      resetDeleteMessages,
    );
    showTostifyMessageAndReset(
      deleteBiopsyErrorMessage,
      showToastifyError,
      resetDeleteMessages,
    );
  }, [
    createBiopsySuccessMessage,
    createBiopsyErrorMessage,
    updateBiopsySuccessMessage,
    updateBiopsyErrorMessage,
    deleteBiopsySuccessMessage,
    deleteBiopsyErrorMessage,
  ]);


  const tableHead = [
    { title: "Appointment ID", key: "appointmentId" },

    { title: "Sample Received Date", key: "sample_rcv_dt" },
    { title: "Sample Received Time", key: "sample_rcv_time" },

    { title: "Grossing Date", key: "grossing_dt" },
    { title: "Grossing Time", key: "grossing_time" },

    { title: "Slide Formation Date", key: "slide_formation_dt" },
    { title: "Slide Formation Time", key: "slide_formation_time" },

    { title: "Slide Receive Date", key: "slide_rcv_dt" },
    { title: "Slide Receive Time", key: "slide_rcv_time" },

    { title: "Report Date", key: "report_dt" },
    { title: "Report Time", key: "report_time" },
  ];

  const handleModal = (action, data = null) => {
    setModalAction(action);

    if (action === "edit" && data) {
      setFormData({
        id: data.id || data._id || "",
        appointmentId: data.appointmentId || "",

        sample_rcv_dt: data.sample_rcv_dt || "",
        sample_rcv_time:
          data.sample_rcv_time && data.sample_rcv_time !== "-"
            ? data.sample_rcv_time
            : "",

        grossing_dt: data.grossing_dt || "",
        grossing_time:
          data.grossing_time && data.grossing_time !== "-"
            ? data.grossing_time
            : "",

        slide_formation_dt: data.slide_formation_dt || "",
        slide_formation_time:
          data.slide_formation_time && data.slide_formation_time !== "-"
            ? data.slide_formation_time
            : "",

        slide_rcv_dt: data.slide_rcv_dt || "",
        slide_rcv_time:
          data.slide_rcv_time && data.slide_rcv_time !== "-"
            ? data.slide_rcv_time
            : "",

        report_dt: data.report_dt || "",
        report_time:
          data.report_time && data.report_time !== "-" ? data.report_time : "",
      });
    } else {
      setFormData({
        id: "",
        appointmentId: "",
        sample_rcv_dt: "",
        sample_rcv_time: "",
        grossing_dt: "",
        grossing_time: "",
        slide_formation_dt: "",
        slide_formation_time: "",
        slide_rcv_dt: "",
        slide_rcv_time: "",
        report_dt: "",
        report_time: "",
      });
    }

    setModalVisible(true);
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setSubmitLoading(true);

    if (modalAction === "create") {
      await dispatch(createBiopsySlice({ ...formData, clinicId, token }));
    } else {
      await dispatch(updateBiopsySlice({ ...formData, clinicId, token }));
    }

    setModalVisible(false);
    setSubmitLoading(false);
    fetchBiopsy();
  };

  const handleDelete = (item) => {
    setDeleteId(item.id);
    setDeleteModalVisible(true);
  };

  const confirmDelete = async () => {
    await dispatch(deleteBiopsySlice({ id: deleteId, clinicId, token }));
    setDeleteModalVisible(false);
    fetchBiopsy();
  };

  const handleView = async (item) => {
    await dispatch(getBiopsyByIdSlice({ id: item.id, clinicId, token }));
    setShowGlobalViewModal(true);
  };

  return (
    <div className="container mt-4">
      <Table
        tableHead={tableHead}
        tableBody={
          biopsy &&
          biopsy.map((item) => ({
            id: item._id,
            appointmentId: item.appointmentId || "",

            sample_rcv_dt: item.sample_rcv_dt
              ? item.sample_rcv_dt.split("T")[0]
              : "",

            sample_rcv_time: item.sample_rcv_time || "",

            grossing_dt: item.grossing_dt ? item.grossing_dt.split("T")[0] : "",

            grossing_time: item.grossing_time || "",

            slide_formation_dt: item.slide_formation_dt
              ? item.slide_formation_dt.split("T")[0]
              : "",

            slide_formation_time: item.slide_formation_time || "",

            slide_rcv_dt: item.slide_rcv_dt
              ? item.slide_rcv_dt.split("T")[0]
              : "",

            slide_rcv_time: item.slide_rcv_time || "",

            report_dt: item.report_dt ? item.report_dt.split("T")[0] : "",

            report_time: item.report_time || "",
          }))
        }
        handleAddBtn={true}
        handleEdit={(item) => handleModal("edit", item)}
        handleDelete={handleDelete}
        handleShowGlobalViewModal={handleView}
        addModal={() => handleModal("create")}
        currentPage={currentPage}
        totalPages={totalPages}
        totalCount={totalCount}
        limit={pageLimit}
        onPageChange={(page) => fetchBiopsy(page, pageLimit)}
        onLimitChange={(lim) => {
          setPageLimit(lim);
          fetchBiopsy(1, lim);
        }}
        isLoading={loading}
      />

      <AddUpdateBiopsy
        showModal={showModal}
        setModalVisible={setModalVisible}
        modalAction={modalAction}
        handleSubmit={handleSubmit}
        formData={formData}
        setFormData={setFormData}
        submitLoading={submitLoading}
      />

      <Modal
        centered
        show={showDeleteModal}
        onHide={() => setDeleteModalVisible(false)}
      >
        <div className="modal-body">
          <p>Are you sure you want to delete this record?</p>
          <button className="btn btn-danger" onClick={confirmDelete}>
            Delete
          </button>
        </div>
      </Modal>

      <ViewModal
        showGlobalViewModal={showGlobalViewModal}
        setShowGlobalViewModal={setShowGlobalViewModal}
        modalSize="lg"
        titel={tableHead}
        content={biopsyById}
      />
    </div>
  );
};

export default BiopsyTracking;
